export enum FundingAccountOperation {
    None = 'none',
    Init = 'init',
    Creating = 'creating',
    Successfull = 'successfull',
    Failed = 'failed',
    Invalid = 'invalid'    
}
